export default {
  init() {
  },
};

const newsAjax = function (post, callback) {
  const $ret = 0;
  const afApp = window.af_app;

  jQuery.ajax({
    type: 'POST',
    dataType: 'json',
    url: afApp.ajaxurl,
    data: post,
    success(data) {
      callback(data);
    },
  });

  return $ret;
};

export const loadNews = function (element) {
  const $this = jQuery(element);
  const newsLoadClass = 'ajax-is-loading-more';
  const newsFilterClass = 'ajax-filter-running';
  const items = jQuery('.news-item').length;

  $('body').addClass(newsLoadClass);

  if (!$('body').hasClass(newsFilterClass)) {
    $('body').addClass(newsFilterClass);

    if ($('body').hasClass(newsLoadClass)) {
      // Block
      $(document).find('.section-news-lobby__items').block({
        message: null,
        overlayCSS: {
          background: '#f7f7f7',
          opacity: 0.6,
        },
      });
    }

    newsAjax({ items, action: 'loadmore_news' }, resp => {
      $('body').removeClass(newsFilterClass);
      if (resp.pagination !== undefined && resp.pagination === false) {
        $this.hide();
      }

      if (resp.success && resp.html !== '') {
        $this.parent().replaceWith(resp.html);
      } else {
        $this.hide();
      }

      $('body').removeClass(newsLoadClass);

      // All done, Unblock
      $(document).find('.section-news-lobby__items').unblock();
    });
  }
};

(function ($, document) {
  const $doc = $(document);

  $doc.ready(() => {
    $doc.on('click', '.news-load-more--btn', function (event) {
      event.preventDefault();
      loadNews(this);
    });
  });
})(jQuery, document);



// WEBPACK FOOTER //
// ./scripts/routes/news.js